module.exports = __webpack_public_path__ + "img/sigin_text.76f1e0c1.png";